import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { useConductorAuth } from '../../contexts/ConductorAuthContext';
import conductorApi from '../../lib/conductorApi';
import { Button } from '../../components/ui/button';
import { Input } from '../../components/ui/input';
import { Label } from '../../components/ui/label';
import { toast } from 'sonner';
import { Lock, KeyRound, LogOut } from 'lucide-react';

export const ConductorCambiarPassword = () => {
  const navigate = useNavigate();
  const { conductor, refresh, logout } = useConductorAuth();
  const isFirstTime = !!conductor?.must_change_password;
  const [current, setCurrent] = useState('');
  const [pwd1, setPwd1] = useState('');
  const [pwd2, setPwd2] = useState('');
  const [loading, setLoading] = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (pwd1.length < 4) {
      toast.error('La nueva contraseña debe tener al menos 4 caracteres');
      return;
    }
    if (pwd1 !== pwd2) {
      toast.error('Las contraseñas no coinciden');
      return;
    }
    setLoading(true);
    try {
      const payload = isFirstTime ? { new_password: pwd1 } : { current_password: current, new_password: pwd1 };
      await conductorApi.post('/conductor/change-password', payload);
      toast.success('Contraseña actualizada');
      await refresh();
      navigate('/conductor', { replace: true });
    } catch (err) {
      toast.error(err.response?.data?.detail || 'Error al cambiar la contraseña');
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="min-h-screen bg-gray-50">
      <header className="bg-white border-b border-gray-200 px-4 py-3 sticky top-0 z-30">
        <div className="flex items-center justify-between max-w-md mx-auto">
          <div className="flex items-center gap-2">
            <KeyRound size={20} className="text-primary" />
            <h1 className="font-bold text-gray-900">Cambiar contraseña</h1>
          </div>
          <button onClick={() => { logout(); navigate('/login'); }} className="text-gray-500" title="Salir">
            <LogOut size={20} />
          </button>
        </div>
      </header>

      <main className="max-w-md mx-auto px-4 py-6">
        {isFirstTime && (
          <div className="bg-amber-50 border border-amber-200 rounded-lg p-4 mb-4 text-sm text-amber-800">
            <p className="font-medium">Es tu primer ingreso</p>
            <p className="mt-1">Por seguridad, define una contraseña personal antes de continuar.</p>
          </div>
        )}

        <form onSubmit={handleSubmit} className="bg-white rounded-xl shadow border border-gray-100 p-5 space-y-4">
          {!isFirstTime && (
            <div>
              <Label className="text-sm">Contraseña actual</Label>
              <div className="relative mt-1">
                <Lock className="absolute left-3 top-1/2 -translate-y-1/2 text-gray-400" size={18} />
                <Input type="password" value={current} onChange={(e) => setCurrent(e.target.value)} className="pl-10 h-12" required data-testid="current-password-input" />
              </div>
            </div>
          )}
          <div>
            <Label className="text-sm">Nueva contraseña</Label>
            <div className="relative mt-1">
              <Lock className="absolute left-3 top-1/2 -translate-y-1/2 text-gray-400" size={18} />
              <Input type="password" value={pwd1} onChange={(e) => setPwd1(e.target.value)} className="pl-10 h-12" required data-testid="new-password-input" />
            </div>
          </div>
          <div>
            <Label className="text-sm">Confirmar nueva contraseña</Label>
            <div className="relative mt-1">
              <Lock className="absolute left-3 top-1/2 -translate-y-1/2 text-gray-400" size={18} />
              <Input type="password" value={pwd2} onChange={(e) => setPwd2(e.target.value)} className="pl-10 h-12" required data-testid="confirm-password-input" />
            </div>
          </div>
          <Button type="submit" disabled={loading} className="w-full h-12 text-base" data-testid="submit-password-change">
            {loading ? 'Guardando...' : 'Guardar contraseña'}
          </Button>
        </form>
      </main>
    </div>
  );
};
